import Auth from './Auth';

export default () =>
  new Headers({
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    Authorization: `Bearer ${Auth.getAccessToken()}`,
  });
